// removed by extract-text-webpack-plugin
module.exports = {"gallery":"edsHm"};